<template>
  <div class="onboarding-layout">
    <main class="onboarding-main">
      <router-view />
    </main>
  </div>
</template>

<script>
export default {
  name: 'OnboardingLayout'
};
</script>

<style scoped>
.onboarding-layout {
  min-height: 100vh;
  background: #fff;
}
.onboarding-main {
  margin: 64px auto 0;
  max-width: 980px;
  padding: 0;
  background: #fff;
  min-height: calc(100vh - 48px);
}
</style>
